// @flow
const TERMS_BUTTON_CLICK = "app/terms/click";
const LOADING_SEMAPHORE_INCREMENT = "app/loading/semaphore/increment";
const LOADING_SEMAPHORE_DECREMENT = "app/loading/semaphore/decrement";
const RIDER_LOCATION_UPDATE = "app/rider/location/update";
const ALERT_DATA_SET = "app/alert/update";
const ALERT_DATA_CLEAR = "app/alert/clear";
const NO_OPERATION = "app/operation/null";
const BLOCKING_TECHNICAL_ISSUE = "app/technical/issue";
const CSS_DIRECTION_SET = "app/css/direction/set";

export default {
    TERMS_BUTTON_CLICK,
    LOADING_SEMAPHORE_INCREMENT,
    LOADING_SEMAPHORE_DECREMENT,
    RIDER_LOCATION_UPDATE,
    ALERT_DATA_SET,
    ALERT_DATA_CLEAR,
    NO_OPERATION,
    BLOCKING_TECHNICAL_ISSUE,
    CSS_DIRECTION_SET,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/App/types.js